module.exports = __webpack_public_path__ + "static/img/xu.1ff0aaad.png";